import { render, staticRenderFns } from "./list.vue?vue&type=template&id=364316c8&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=364316c8&lang=scss&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364316c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364316c8')) {
      api.createRecord('364316c8', component.options)
    } else {
      api.reload('364316c8', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=364316c8&scoped=true&", function () {
      api.rerender('364316c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/kbVlog/list/list.vue"
export default component.exports